import clsx from 'clsx';
import { Icon } from 'common/icon';
import Link from 'next/link';
import { SelectArrow } from './arrow';
import styles from './styles.module.css';

interface SearchLinkProps {
  title: string;
  variant?: 'small' | 'medium';
  href: string;
  className?: string;
}

export const SearchLink = ({
  title,
  variant,
  href,
  className,
}: SearchLinkProps) => {
  return (
    <Link href={href} className={clsx(styles.item, className)}>
      <div className={styles.button}>
        <Icon.Guide />
        <div className={styles.question}>
          <p className={styles.text}>{title}</p>
        </div>
        <div className={styles.arrow}>
          <SelectArrow isOpen={false} size={variant} />
        </div>
      </div>
    </Link>
  );
};
